export const menu = [
  {
    title: '首页',
    url: '/',
  },
  {
    title: '走进万豪',
    url: '/about-us',
    children: [
      {
        title: '公司简介',
        url: '/about-us/company-introduction',
        coverPic: require('@/assets/img/cate-menu-cover-pic/about-us/1.公司简介.jpg'),
      },
      // {
      //   title: '核心团队',
      //   url: '/about-us/expert-team',
      //   coverPic: require('@/assets/img/cate-menu-cover-pic/about-us/2.核心团队.jpg'),
      // },
      {
        title: '资源矩阵',
        url: '/about-us/resource-matrix',
        coverPic: require('@/assets/img/cate-menu-cover-pic/about-us/3.资源矩阵.jpg'),
      },
      {
        title: '发展历程',
        url: '/about-us/mile-stone',
        coverPic: require('@/assets/img/cate-menu-cover-pic/about-us/4.大事记.jpg'),
      },
      {
        title: '资质荣誉',
        url: '/about-us/honor',
        coverPic: require('@/assets/img/cate-menu-cover-pic/about-us/5.荣誉资质.jpg'),
      }
    ]
  },
  {
    title: '新闻动态',
    url: '/news-focus/cate-list/21',
    children: [
      {
        title: '聚焦万豪',
        eng: 'Focus',
        url: '/news-focus/cate-list/21',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/zlgh.png'),
      },
      {
        title: '党建工作',
        eng: 'Party Building Work',
        url: '/news-focus/cate-list/22',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/zlgh.png'),
      },
      {
        title: '媒体资讯',
        eng: 'Media Information',
        url: '/news-focus/cate-list/23',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/zlgh.png'),
      }
    ]
  },
  {
    title: '政府类服务',
    url: '/gov-service/index',
    children: [
      {
        title: '战略规划',
        url: '/gov-service/detail/战略规划',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/zlgh.png'),
        description: '产业规划、城乡规划、园区规划、质量及标准化规划'
      },
      {
        title: '标准研制',
        url: '/gov-service/detail/标准研制',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/bzyz.png'),
        description: '国家标准、行业标准、地方标准、团体标准、企业标准'
      },
      {
        title: '标准化项目建设',
        url: '/gov-service/detail/标准化项目建设',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/bzhxmjs.png'),
        description: '农业/农村类、新型城镇化类、基本公共服务类、政务服务类、旅游服务类'
      },
      {
        title: '质量提升项目建设',
        url: '/gov-service/detail/质量提升项目建设',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/zltsxmjs.png'),
        description: '质量强市创建城市示范区建设、政府质量奖评审、质量论坛组织、出口产品质量安全示范区建设、质量对标提升建设'
      },
      {
        title: '课题研究',
        url: '/gov-service/detail/课题研究',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/ktyj.png'),
        description: '课题研究'
      },
      {
        title: '培训服务',
        url: '/gov-service/detail/培训服务',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/pxfw.png'),
        description: '各类培训'
      },
      {
        title: '有机产品项目建设',
        url: '/gov-service/detail/有机产品项目建设',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/yjcpjs.png'),
        description: '省级有机产品认证创建示范区建设、国家级有机产品认证创建示范区建设'
      },
      {
        title: '地理标志产品保护',
        url: '/gov-service/detail/地理标志产品保护',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/dlbzcpbh.png'),
        description: '国家地理标志产品申报、农产品地理标志产品申请、地理标志证明商标、农产品地理标志产品示范区创建'
      },

      {
        title: '品牌建设',
        url: '/gov-service/detail/品牌建设',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/ppjs.png'),
        description: '区域公用品牌建设、品牌发展规划、品牌策划'
      },
      {
        title: '视觉设计',
        url: '/gov-service/detail/视觉设计',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/sjsj.png'),
        description: '形象设计、导视系统设计、平面设计、规划设计'
      },
      {
        title: '环保咨询',
        url: '/gov-service/detail/环保咨询',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/hbzx.png'),
        description: '生态环境专项规划、环境保护工程可行性研究报告、污染源调查、环境影响评价及竣工环保验收、排污许可证申报'
      },
      {
        title: '软件开发',
        url: '/gov-service/detail/软件开发',
        coverPic: require('@/assets/img/cate-menu-cover-pic/gov/rjkf.png'),
        description: '智慧农业类平台、综合执法类系统、质量技术服务类平台、商户信用平台、政务类平台'
      }
    ]
  },
  {
    title: '企业类服务',
    url: '/ent-service/index',
    children: [
      {
        title: '高新技术企业服务',
        url: '/ent-service/detail/高新技术企业服务',
        coverPic: require('@/assets/img/cate-menu-cover-pic/ent/gxjsqyfw.png'),
        description: '高新企业认定工作、企业技术中心认定、各类资金项目申报'
      },
      {
        title: '财务咨询',
        url: '/ent-service/detail/财务咨询',
        coverPic: require('@/assets/img/cate-menu-cover-pic/ent/cwzx.png'),
        description: '专审年报、研发费加计扣除、财务管理规范指导、成本结构分析优化'
      },
      {
        title: '知识产权综合服务',
        url: '/ent-service/detail/知识产权综合服务',
        coverPic: require('@/assets/img/cate-menu-cover-pic/ent/zscqzhfw.png'),
        description: '知识产权综合服务'
      },
      {
        title: '企业质量管理与标准化建设',
        url: '/ent-service/detail/企业质量管理与标准化建设',
        coverPic: require('@/assets/img/cate-menu-cover-pic/ent/zlglybzhjs.png'),
        description: '企业质量诊断与卓越绩效导入辅导、6S可视化管理、企业标准良好行为建设'
      }
    ]
  },
  {
    title: '成果展示',
    url: '/progress-show/cate-list/15',
    children: [
      {
        title: '战略规划',
        eng: 'Strategic Planning',
        url: '/progress-show/cate-list/15',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/7战略规划.png'),
      },
      {
        title: '标准研制',
        eng: 'Standard Development',
        url: '/progress-show/cate-list/9',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/1标准研制.png'),
      },
      {
        title: '标准化项目建设',
        eng: 'Standardization Project Construction',
        url: '/progress-show/cate-list/10',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/2标准化建设项目.png'),
      },
      {
        title: '地理标志产品保护',
        eng: 'Geographical Indication Product Protection',
        url: '/progress-show/cate-list/11',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/3地理标志保护.png'),
      },
      {
        title: '有机产品项目建设',
        eng: 'Organic Product Project Construction',
        url: '/progress-show/cate-list/12',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/4有机产品项目建设.png'),
      },
      {
        title: '质量提升项目建设',
        eng: 'Quality Improvement Project Construction',
        url: '/progress-show/cate-list/13',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/5质量提升项目建设.png'),
      },
      {
        title: '品牌建设',
        eng: 'Brand Building',
        url: '/progress-show/cate-list/14',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/6品牌建设.png'),
      },
      {
        title: '视觉设计',
        eng: 'Visual Design',
        url: '/progress-show/cate-list/17',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/9视觉设计.png'),
      },
      {
        title: '软件开发',
        eng: 'Software Development',
        url: '/progress-show/cate-list/18',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/10软件开发.png'),
      },
      {
        title: '环保咨询',
        eng: 'Environmental Consulting',
        url: '/progress-show/cate-list/19',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/11环保咨询.png'),
      },
      {
        title: '课题研究',
        eng: 'Subject Research',
        url: '/progress-show/cate-list/16',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/8课题研究.png'),
      },
      {
        title: '培训服务',
        eng: 'Training Services',
        url: '/progress-show/cate-list/20',
        coverPic: require('@/assets/img/cate-menu-cover-pic/progress-show/12培训服务.png'),
      }
    ]
  },
  {
    title: '招贤纳士',
    url: '/recruitment'
  },
  {
    title: '联系我们',
    url: '/contact-us'
  },
  // {
  //   title: '在线教育',
  //   url: '/developing'
  // }
]

export const expertCate = [
  {
    text :'标准化服务',
    value: '1'
  },
  {
    text :'质量提升',
    value: '2'
  },
  {
    text :'环保服务',
    value: '3'
  },
  {
    text :'规划与设计',
    value: '4'
  },
  {
    text :'软件开发',
    value: '5'
  },
  {
    text :'高企服务',
    value: '6'
  },
  {
    text :'专利申请',
    value: '7'
  }
]

